import { useParams, Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axiosInstance from "../axios/axios";
import uploadBtn from "../assets/uploadBtn.svg";
import Loader from "./Loader";

const ViewJobApplications = () => {
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(false);
  const org_id = localStorage.getItem("role_specific_id");
  const { id } = useParams();

  useEffect(() => {
    const fetchViewedApplication = async () => {
      setLoading(true);
      try {
        const res = await axiosInstance.get(
          `ViewApplicationByOrg/${org_id}?job_id=${id}`
        );

        console.log(res.data.applications);
        setApplications(res.data.applications || []);
      } catch (error) {
        console.error("Error fetching applications:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchViewedApplication();
  }, [id, org_id]);

  const calculateDaysAgo = (createdAt) => {
    const createdDate = new Date(createdAt);
    const today = new Date();

    // Normalize to midnight for accurate date comparisons
    today.setHours(0, 0, 0, 0);
    createdDate.setHours(0, 0, 0, 0);

    const timeDifference = createdDate - today; // Difference in milliseconds
    const daysAgo = Math.floor(timeDifference / (1000 * 60 * 60 * 24)); // Convert to days

    if (daysAgo === 0) return "Today";
    if (daysAgo === -1) return "Yesterday";
    if (daysAgo < 0) return `${Math.abs(daysAgo)} days ago`; // Past dates
    return `In ${daysAgo} days`; // Future dates
  };
  if (loading) return <Loader />;
  return (
    <>
      <div className="flex justify-between py-3 px-2 items-center w-full top-bar">
        <span>Applications</span>
        <Link
          to="/dashboard/create-job"
          className="hidden md:flex gap-2 items-center justify-center rounded-[8px] border-2 border-[#049645] py-[10px] px-[14px]"
        >
          <img src={uploadBtn} alt="Upload Button" />
          <map>Create Job</map>
        </Link>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 p-6 ">
        {applications.length === 0 ? (
          <div>
            <p>No applications found.</p>
            <Link to="/dashboard/applications" className="btn">
              Go Back
            </Link>
          </div>
        ) : (
          applications.map((app) => (
            <div
              key={app.id}
              className="flex border rounded-lg gap-[17px] my-[24px] p-[24px] w-full flex-col"
            >
              <div className="role-title">
                {app.job.job_title || "Untitled Job"}
              </div>
              <div>
                <span className="text-gray-600">
                  {app?.user?.student?.full_name || "Unknown Applicant"}
                </span>{" "}
                -{" "}
                <span className="text-gray-600">
                  {app?.user?.student?.university || "Unknown University"}
                </span>
              </div>
              <span>{app.cover_letter || "No cover letter provided."}</span>
              <div className="flex justify-between my-6">
                <span>{calculateDaysAgo(app.created_at)}</span>
                <Link
                  to={`/dashboard/applications/${app.id}`}
                  className="btn btn-success"
                >
                  View Application
                </Link>
              </div>
            </div>
          ))
        )}
      </div>
    </>
  );
};

export default ViewJobApplications;
